import BonusEligibility from '@core/models/bonus/BonusEligibility';
import BetBonusEligibilityDto from '@core/mappers/bonus/dtos/BetBonusEligibilityDto';

import {
    areFieldsSet,
    parseAspDate,
} from '@superbet-group/web.lib.utilities';
import { transformEventOdds } from './transformEventOdds';
import { transformUtilizationEvent } from './transformUtilizationEvent';
import { transformUtilizationBetType } from './transformUtilizationBetType';

export function transformBonusEligibility(dto: BetBonusEligibilityDto): BonusEligibility {
    return {
        name: dto.FriendlyName || dto.Name,
        bonusId: dto.PlayerBonusId,
        balance: dto.BonusBalance,
        status: dto.BonusStatus,
        utilization: dto.BonusUtilization,
        cashType: dto.CashType,
        winType: dto.WinCreditType,
        eventsOdds: dto.betEligibility.MinOddLevelForEachEvent?.map((event) => transformEventOdds(event)) ?? [],

        ...areFieldsSet(dto, 'ExpirationDate') && { expirationDate: parseDateWithUnknownFormat(dto.ExpirationDate) },
        ...areFieldsSet(dto.betEligibility, 'MinNumberOfMultipleTicketEvents') && { minMultipleTicketEvents: dto.betEligibility.MinNumberOfMultipleTicketEvents },
        ...areFieldsSet(dto.betEligibility, 'MinOddForMultiple') && { minMultipleTicketOdd: dto.betEligibility.MinOddForMultiple },
        ...areFieldsSet(dto.betEligibility, 'MinOddWithinMultiple') && { minEventOddInMultipleTicket: dto.betEligibility.MinOddWithinMultiple },
        ...areFieldsSet(dto.betEligibility, 'UtilizationEvents') && { utilizationEvents: dto.betEligibility.UtilizationEvents.map((event) => transformUtilizationEvent(event)) },
        ...areFieldsSet(dto.betEligibility, 'UtilizationBetTypes') && { utilizationBetTypes: dto.betEligibility.UtilizationBetTypes.map((type) => transformUtilizationBetType(type)) },
    };
}

function parseDateWithUnknownFormat(input: string): Date {
    // This will parse following format: 'YYYY-MM-DDTHH:mm:ssZ'
    const date = new Date(input);
    if (!isNaN(date.getTime())) {
        return date;
    }

    // This will parse following format: '/Date(number)/'
    return parseAspDate(input);
}
